"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARTICLEV2_PREVIEW_TYPE = exports.ARTICLEV2_ICON_CLASS = exports.ARTICLEV2_HTML_FORMAT_NAME = exports.ARTICLEV2_PACKAGE_FORMAT_NAME = exports.ARTICLEV2_TYPE_TEXT = exports.ARTICLEV2_FORMAT_NAME = exports.ARTICLEV2_TYPE_NAME = exports.ARTICLEV2_OBJECT_TYPE13 = exports.ARTICLEV2_CONTENT_TYPE = exports.ARTICLEV2_FORMAT = exports.ARTICLEV2_OBJECT_TYPE = exports.ARTICLEV2_TYPE = exports.ArticleV2Service = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var User_service_1 = require("./User.service");
var ArticleV2Service = /** @class */ (function () {
    function ArticleV2Service(userService) {
        this.userService = userService;
    }
    /**
     * shield server side logic
     * business params: type, format, objectType, contentType
     * custom params: __TEMP_MODE__ ['default', 'objectType13']
     *
     * default
     * type=23(current used in doccenter, predictive content)
     * objectType=36(current used in newscenter)
     * contentType=13(current used in globalsearch and doccenter)
     * type=Page(current used in contentmanager)
     *
     * objectType13
     * objectType=13(current used in adminsetting)
     */
    ArticleV2Service.prototype.isArticlev2ForDefault = function (data) {
        return (data.type === exports.ARTICLEV2_TYPE)
            || (data.type === exports.ARTICLEV2_TYPE_NAME)
            || (data.objectType === exports.ARTICLEV2_OBJECT_TYPE)
            || (data.contentType === exports.ARTICLEV2_CONTENT_TYPE);
    };
    ArticleV2Service.prototype.isArticlev2ForObjectType13 = function (objectType) {
        return (objectType === exports.ARTICLEV2_OBJECT_TYPE13);
    };
    ArticleV2Service.prototype.isArticlev2 = function (data) {
        switch (data.__TEMP_MODE__ || 'default') {
            case 'default':
                return this.isArticlev2ForDefault({
                    type: data.type,
                    objectType: data.objectType,
                    contentType: data.contentType,
                });
            case 'objectType13':
                return this.isArticlev2ForObjectType13(data.objectType);
        }
        return false;
    };
    // temp code using to articlev2 integrate phase1
    ArticleV2Service.prototype.getArticlev2OnlineTemplate = function (structure, contentName, language) {
        if (contentName === void 0) { contentName = ''; }
        if (language === void 0) { language = 'en-US'; }
        var cssUrl = window.seismicArticlev2WebViewerCSS;
        var jsUrl = window.seismicArticlev2WebViewerJS;
        var customHeaders = { SeismicClientName: this.userService.getLoginInfo().clientType };
        var authToken = this.userService.getAccessToken();
        var loginInfoTemplate = __assign({}, this.userService.getLoginInfo());
        delete loginInfoTemplate.clientInfo;
        var jsonCustomHeaders = '{}';
        try {
            jsonCustomHeaders = JSON.stringify(customHeaders);
        }
        catch (e) {
            console.error('customHeaders stringfy error', customHeaders);
        }
        return "<!DOCTYPE html>\n    <html>\n    <head>\n        <meta charset=\"utf-8\" />\n        <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n        <link rel=\"stylesheet\" href=\"" + cssUrl + "\">\n        <title></title>\n        <style>\n            template {\n                display: none;\n            }\n        </style>\n        <script>\n            window.__custom_headers__ = " + jsonCustomHeaders + ";\n            window.__content_name__ = \"" + contentName + "\";\n            window.__custom_language__= \"" + language + "\";\n            window.__cdn_url__ = \"" + window.__cdn_url__ + "\";\n            window.localWebCDNUrl = \"" + window.localWebCDNUrl + "\";\n            window.versionJSFolder = \"" + window.versionJSFolder + "\";\n            window.authSetting = {\n                authToken: \"" + authToken + "\",\n                loginInfo: " + JSON.stringify(loginInfoTemplate, null, 4) + ",\n                timeZoneOffset: " + window.$App.timeZoneOffset + ",\n\n            };\n            window.microServiceSetting = {\n                serviceDiscoveryServiceUrl: \"\",\n                address: \"" + window.$App.ApplicationInfo.serviceAddress.article + "\"\n            };\n            window.authToken = \"" + authToken + "\";\n            window.isDebug = " + (window.isDebug === 'True') + ";\n        </script>\n    </head>\n    <body>\n        " + structure + "\n    </body>\n    <script type=\"text/javascript\" src=\"" + jsUrl + "\"></script>\n    </html>\n    ";
    };
    // temp code for migrate articlev1
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    ArticleV2Service.prototype.isArticleV2VersionByHtml = function (data, html) {
        var markFlag = '<script id=\'structure\' type=\'application/json\'>';
        var markStr = (html || '').slice(0, markFlag.length);
        if (markStr.length !== markFlag.length)
            return false;
        if (markStr === markFlag)
            return true;
        return false;
    };
    ArticleV2Service = __decorate([
        CommonService_decorator_1.CommonService('ArticleV2Service'),
        __metadata("design:paramtypes", [User_service_1.UserService])
    ], ArticleV2Service);
    return ArticleV2Service;
}());
exports.ArticleV2Service = ArticleV2Service;
exports.ARTICLEV2_TYPE = 23;
exports.ARTICLEV2_OBJECT_TYPE = 36;
exports.ARTICLEV2_FORMAT = 54;
exports.ARTICLEV2_CONTENT_TYPE = 13;
exports.ARTICLEV2_OBJECT_TYPE13 = 13;
exports.ARTICLEV2_TYPE_NAME = 'Page';
exports.ARTICLEV2_FORMAT_NAME = 'JSON';
exports.ARTICLEV2_TYPE_TEXT = 'Article';
exports.ARTICLEV2_PACKAGE_FORMAT_NAME = 'zip';
exports.ARTICLEV2_HTML_FORMAT_NAME = 'HTML';
exports.ARTICLEV2_ICON_CLASS = 'article-type';
exports.ARTICLEV2_PREVIEW_TYPE = 'HTML';
//# sourceMappingURL=ArticleV2.service.js.map